<style lang="scss" scoped>
.modal-card {
  @media screen and (min-width: 769px) {
    width: 800px;
  }
}
</style>
<template>
  <div class="modal is-active">
    <div class="modal-background" />
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          Add New Art
        </p>
        <button
          class="delete"
          @click="$emit('closeModal')"
        />
      </header>
      <section class="modal-card-body">
        <ArtForm
          ref="artForm"
          :art.sync="art"
          :new-art="true"
        />
      </section>
      <footer class="modal-card-foot">
        <button
          :class="{'is-loading': saving}"
          class="button is-success"
          @click="createArt"
        >
          Create Art
        </button>
        <button
          class="button"
          @click="$emit('closeModal')"
        >
          Cancel
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ArtForm from '@/components/Art/ArtForm.vue';

export default {
  name: 'NewArtModal',
  components: {
    ArtForm,
  },
  data() {
    return {
      art: { tags: [] },
      saving: false,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.profile.user,
      jwt: (state) => state.profile.jwt,
    }),
    API() {
      return this.$API;
    },
  },
  methods: {
    createArt() {
      this.saving = true;
      this.$refs.artForm.saveArt();
      setTimeout(() => {
        this.saving = false;
        this.$emit('closeModal');
      }, 1000);
    },
  },
};
</script>
